import type { AxiosResponse } from 'axios';
import api from 'src/services/api';
import * as utils from './apiUtils';
import {
  type AdminGroup2IndexResponse,
  type AdminGroup2Response,
  type AdminGroup2DestroyResponse,
  toAdminGroup2,
} from 'src/models/apis/group2/adminGroup2Response';
import type { AdminGroup2 } from 'src/models/group2';
import type { AdminGroup2Params } from 'src/models/apis/group2/adminGroup2Request';

export default {
  async adminIndex(): Promise<AdminGroup2[]> {
    const response = await api.get<AdminGroup2IndexResponse>(utils.getApiUrl('/admin/groups2'));
    return response.data.map(toAdminGroup2);
  },
  async adminCreate(params: AdminGroup2Params): Promise<AdminGroup2> {
    const response = await api.post<AdminGroup2Response>(utils.getApiUrl('/admin/groups2'), params);
    return toAdminGroup2(response.data);
  },
  async adminUpdate(id: number, params: AdminGroup2Params): Promise<AdminGroup2> {
    const response = await api.put<AdminGroup2Response>(utils.getApiUrl(`/admin/groups2/${id}`), params);
    return toAdminGroup2(response.data);
  },
  // AdminGroup2DestroyResponse に対応する camelCase マッパーが未定義のため AxiosResponse を維持
  adminDestroy(id: number): Promise<AxiosResponse<AdminGroup2DestroyResponse>> {
    return api.delete(utils.getApiUrl(`/admin/groups2/${id}`));
  },
};
